import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=46d80caf&scoped=true&"
import script from "./TabsView.vue?vue&type=script&lang=ts&"
export * from "./TabsView.vue?vue&type=script&lang=ts&"
import style0 from "./TabsView.vue?vue&type=style&index=0&id=46d80caf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d80caf",
  null
  
)

export default component.exports